import { Link } from 'react-router-dom';
import { resolveImagePath } from '@/utils/imageMap';

interface ServiceImage {
  src: string;
  alt: string;
}

interface Service {
  title: string;
  image: ServiceImage;
  description: string;
  href: string;
}

interface ServicesProps {
  services: Service[];
}

export function Services({ services }: ServicesProps) {
  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {services.map((service, index) => (
            <div key={index} className="text-center">
              {/* Service Image */}
              <div className="mb-6">
                <Link 
                  to={service.href}
                  className="block group"
                >
                  <div className="relative overflow-hidden rounded-lg shadow-lg group-hover:shadow-xl transition-shadow duration-300">
                    <img
                      src={resolveImagePath(service.image.src)}
                      alt={service.image.alt}
                      className="w-full h-64 md:h-72 object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    {/* Hover overlay */}
                    <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                </Link>
              </div>

              {/* Service Title */}
              <h2 className="font-nav text-xl md:text-2xl font-bold text-neutral-dark mb-4">
                <Link 
                  to={service.href}
                  className="hover:text-primary transition-colors duration-200"
                >
                  {service.title}
                </Link>
              </h2>

              {/* Service Description */}
              <div className="font-body text-neutral-dark text-sm md:text-base leading-relaxed mb-6">
                <p>{service.description}</p>
              </div>

              {/* Read More Link */}
              <div className="mt-4">
                <Link
                  to={service.href}
                  className="inline-flex items-center text-primary hover:text-primary-blue font-nav font-bold transition-colors duration-200"
                >
                  Learn More
                  <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}